<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getLocaleColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [-1, 20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        hide-default-footer
        fixed-header
        :item-class="itemRowBackground"
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="128">
          <v-text-field
              v-model="searchTerm"
              :label="$t('search')"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn icon class="mt-n5" @click="onWeekPrev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-autocomplete
            v-model="selectWeekStart"
            :items="getWeekStartDates"
            :label="$t('week')"
            outlined
            dense
            @input="onUpdateFilters"
            auto-select-first
          ></v-autocomplete>
          <v-btn icon class="mt-n5" @click="onWeekNext">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn tile class="mt-n6" @click="onToday">
            {{ $t('today') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-checkbox v-model="activeHumanUser" :label="$t('active_user')" @change="onUpdateFilters"></v-checkbox>
        </v-toolbar>

      </template>
      <template v-slot:item.human_user="{ item }">
        <span v-if="item.human_user != null">{{ item.human_user.user }} ({{ item.human_user.employee_number }})</span>
      </template>
      <template v-slot:item.department="{ item }">
        <span v-if="item.human_user != null">{{ item.human_user.department.department }}</span>
      </template>
      <template v-slot:item.current_vacation="{ item }">
        {{ item.holiday_year }}/{{ item.holiday_planed }}
      </template>
      <template v-for="column in getColumns.slice(3)" v-slot:[`item.${column.value}`]="{ item }">
        <v-chip label x-small v-for="(val, key, index) in item[column.value]" class="px-1 mx-1" :color="getDateColor(val)">
          {{ val.day }}
        </v-chip>
      </template>
    </v-data-table>
    <ConfirmDialog :confirm_request="confirm_request" :fetch-request="fetchRequest"></ConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import CustomerOrderItem from "@/components/BatchRun/CustomerOrder/CustomerOrderItem";
import ConfirmDialog from "@/components/Base/ConfirmDialog";

export default {
  name: 'CalendarVacationTable',
  props: {
    subtractHeight: {type: [Number], default: 160},
    height: {type: [Number], default: window.innerHeight},
    dto_model: {type: [String], default: 'CalendarVacationListQueryDTO'},
  },

  components: {
    CustomerOrderItem,
    ConfirmDialog,
  },

  computed: {
    ...mapGetters('CalendarVacationTable', ['getColumns']),
    ...mapFields('CalendarVacationTable', ['message_error', 'options', 'totalRecords', 'options.page', 'itemList',
      'itemListCommon',
      'loading', 'selectedItemList', 'searchTermFile', 'searchTerm', 'filters', 'errorMessage', 'filtersArg',
      'confirm_request', 'statusCustomerOrder']),

    getLocaleColumns() {
      let columns = []
      for ( const [index, column] of this.getColumns.entries()) {
        let text = column.text
        if (index < 3) {
          text = this.$t('columns.' + column.value)
        }
        // console.log('text', text)
        if (!!text)
          column.text = text
        columns.push(column)
      }
      return columns
    },

    getWeekStartDates() {
      // console.log('getWeekStartDates', this.itemListCommon)
      let weeks = []
      if (this.itemListCommon && this.itemListCommon.year_week)
        for (let row of this.itemListCommon.year_week)
          weeks.push(row.start_week_date)
      return weeks
    },
  },

  methods: {
    ...mapActions('CalendarVacationTable', ['openWebSocket', 'fetchItemList', 'fetchItem',
      'fetchSaveItemField', 'fetchActionSelectedItem', 'fetchActionItem', 'fetchRequest']),

    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },

    itemRowBackground: function (item) {
      // console.log('itemRowBackground', this.statusCustomerOrder, item)
      return null
    },

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList(this.dto_model)
    },

    onUpdateFilters() {
      // console.log('onUpdateOptions')
      this.options.page = 1
      this.filters = []
      if (this.activeHumanUser)
        this.filters.push({param_compare: 'human_user__active', value: this.activeHumanUser})
      if (this.selectWeekStart) {
        let current = new Date(this.selectWeekStart);
        current.setDate(current.getDate() + 7 * 4);
        this.filters.push({param_compare: 'calendar_date__dt__lt', value: current.toISOString().split('T')[0]})
        current = new Date(this.selectWeekStart);
        current.setDate(current.getDate() - 7 * 3);
        this.filters.push({param_compare: 'calendar_date__dt__gte', value: current.toISOString().split('T')[0]})
      }
      this.fetchItemList(this.dto_model)
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList(this.dto_model)
    }, 800),

    getDateColor(val) {
      // console.log('getDateColor', val)
      if (!!val.hol)
        return 'red lighten-1'
      if (!!val.vac)
        return 'red lighten-3'
    },
    onWeekNext() {
      let index = this.getWeekStartDates.indexOf(this.selectWeekStart)
      if (index > 0) {
        this.selectWeekStart = this.getWeekStartDates[index - 1]
        this.onUpdateFilters()
      }
    },
    onWeekPrev() {
      let index = this.getWeekStartDates.indexOf(this.selectWeekStart)
      if (index < this.getWeekStartDates.length - 1) {
        this.selectWeekStart = this.getWeekStartDates[index + 1]
        this.onUpdateFilters()
      }
    },
    onToday(mount = false) {
      let current_date = new Date()
      this.selectWeekStart = new Date(current_date.setDate(current_date.getDate() - current_date.getDay() + 1))
      this.selectWeekStart = this.selectWeekStart.toISOString().split('T')[0]
      if (mount !== true)
        this.onUpdateFilters()
    },
  },

  async mounted() {
    // console.log('mounted')
    this.searchTerm = null
    this.onToday(true)
  },

  created() {
  },
  destroyed() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      selectWeekStart: null,
      activeHumanUser: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.status_production {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.status_completely_delivered, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child {
  background-color: #FFF8E1 !important;
}

/*.status_production {*/
/*  background-color: #FFEBEE !important;*/
/*}*/

</style>

<i18n src=".\locales.json">
</i18n>
